import(/* webpackMode: "eager" */ "/app/src/app/[lang]/page.tsx");
